import { Pie } from 'vue-chartjs'

export default {
  name: 'pie-chart',
  mixins: [Pie]
}
